const initVideo = () => {
    const video = document.querySelector("[data-video]");
    const loader = document.querySelector("[data-loader]");
    if (video && loader) {
        loader.classList.add("active");
        //https://stackoverflow.com/questions/8685038/tell-whether-video-is-loaded-or-not-in-javascript
        video.addEventListener('loadeddata', (e) => {
            if (video.readyState >= 3) {
                loader.classList.remove("active");
            }
        });
    }
};
